import {Component, Prop} from "vue-property-decorator";
import Modal from "@/assets/common/Modal/Modal.vue";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal.vue";

@Component({
    components: {
        Modal
    },
})
export default class ProducerSelectModal extends ItemSelectModal {
    @Prop({default: () => "生産者"})
    itemKindName!: string

    @Prop()
    apiPath!: string;

    @Prop({default: () => true})
    multiple!: boolean

    @Prop({default: () => false})
    editable!: boolean
}
